import { useQuery } from '@tanstack/react-query';

import { useUserQuery } from '@/features/users';

import { getXeroInvoiceStatus } from '../api';
import { xeroInvoiceQueryKeys } from '../data';

export const useXeroInvoiceStatus = () => {
  const user = useUserQuery();

  return useQuery({
    queryKey: xeroInvoiceQueryKeys.status,
    queryFn: getXeroInvoiceStatus,
    enabled: Boolean(user.data?.company_id),
    retry: 0,
    refetchOnMount: true,
    staleTime: 0,
  });
};
